var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoIosAppStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M19.152 0H4.848A4.846 4.846 0 0 0 0 4.848v14.307A4.845 4.845 0 0 0 4.848 24h14.307a4.848 4.848 0 0 0 4.848-4.848V4.848A4.85 4.85 0 0 0 19.152 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.898 5.514.486-.84a1.093 1.093 0 1 1 1.896 1.092l-4.683 8.106h3.387c1.098 0 1.713 1.29 1.236 2.184H4.29a1.088 1.088 0 0 1-1.092-1.092c0-.606.486-1.092 1.092-1.092h2.784l3.564-6.177-1.113-1.932a1.095 1.095 0 0 1 1.896-1.092l.477.843ZM7.686 17.18 6.636 19a1.093 1.093 0 1 1-1.896-1.09l.78-1.35c.882-.273 1.599-.063 2.166.62Zm9.042-3.303h2.841c.606 0 1.092.486 1.092 1.092 0 .606-.486 1.092-1.092 1.092h-1.578l1.065 1.848a1.095 1.095 0 0 1-1.896 1.092c-1.794-3.111-3.141-5.44-4.035-6.99-.915-1.578-.261-3.162.384-3.7.717 1.23 1.788 3.088 3.219 5.566Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.002,
    x2: 12.002,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2072F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoIosAppStore);
export default __webpack_public_path__ + "static/media/ic_logo_ios_app_store.6df562c0eb913465710bdb7195c4694c.svg";
export { ForwardRef as ReactComponent };